import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import {TextField} from '../nimbus/textField';
import {Validators} from 'services';
import {TranslationMixin} from 'mixins/translationMixin';
import {WithCommonTranslations} from 'components/hocs';

import './FormInput.css';

export const FormInput = WithCommonTranslations(
    class extends TranslationMixin(React.Component) {

      constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
          errorMessage: '',
          error: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.setErrorState = this.setErrorState.bind(this);
      }

      componentDidMount() {
        const dom = ReactDOM.findDOMNode(this.inputRef.current);
        const input = dom.querySelector('input');
        this.setErrorState(input);
      }

      componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.required !== prevProps.required ||
            this.props.customError !== prevProps.customError ||
            this.props.readOnly !== prevProps.readOnly ||
            this.props.value !== prevProps.value ||
            this.props.max !== prevProps.max ||
            this.props.min !== prevProps.min ||
            this.props.pattern !== prevProps.pattern) {
          const dom = ReactDOM.findDOMNode(this.inputRef.current);
          const input = dom.querySelector('input');
          this.setErrorState(input);
        }
      }

      handleChange(event) {
        const input = event.target;
        const self = this;
        input.setCustomValidity('');
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(event, function() {
            self.setErrorState(input);
          });
        }
      }

      setErrorState(input) {
        if (this.props.type === 'email') {
          Validators.validateEmail(input);
        }

        let errorMsg = Validators.getValidityMessage(input);

        this.setState({
          errorMessage: errorMsg,
          error: errorMsg ? true : false,
        });
      }

      render() {
        const {
          label,
          type,
          id,
          required,
          displayError,
          message,
          readOnly,
          onChange,
          customError,
          ...otherProps
        } = this.props;

        const displayType = (type === 'email' ? 'text' : type);
        return (
            <div className={"tdsInput mb-3" + (required ? ' required-field' : '')}>
              <TextField
                  className={this.props.readOnly ? 'readOnly' : ''}
                  ref={this.inputRef}
                  id={id}
                  label={label}
                  readOnly={readOnly}
                  type={displayType}
                  required={required}
                  message={message ? this.getTranslation(message, message) : ""}
                  onChange={this.handleChange}
                  error={displayError &&
                  (this.state.error ||
                      (this.props.customError ? true : false))}
                  errorMessage={this.getTranslation(this.state.errorMessage,
                      this.state.errorMessage) ||
                  this.props.customError}
                  {...otherProps}/>
            </div>
        );
      }
    });

FormInput.propTypes = {
  customError: PropTypes.string,
  displayError: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  message: PropTypes.node,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'password', 'number', 'email']),
};

FormInput.defaultProps = {
  type: 'text',
  required: false,
  onChange: undefined,
};